import * as React from 'react';
import { Box, Chip } from '@material-ui/core';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import useStyles from '../../ApprovalManagement/ConfirmAdmissionScreen/styles/leadDetails';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  height: 540,
  overflowY: 'scroll',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const View = ({ details }) => {
  const classes = useStyles();
  return (
    <Box sx={style}>
      <div className={classes.seconudcontainer}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className={classes.leadborder}>
              <div>
                <div className={classes.details}>
                  <div
                    className={classes.fontleadbold}
                    style={{
                      marginBottom: '0.5rem',
                      paddingTop: '0px',
                      marginTop: '0px',
                    }}>
                    Order Details
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Username</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details &&
                            details.user &&
                            details.user[0] &&
                            details.user[0].name}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Email</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details &&
                            details.user &&
                            details.user[0] &&
                            details.user[0].email}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Phone</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details &&
                            details.user &&
                            details.user[0] &&
                            details.user[0].mobile}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Id</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>{details._id}</div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Subtotal</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details.subtotal}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Discount</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details.offer}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Total</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details.total}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Status</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details.status}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Order Id</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details.orderId}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Currency</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details.metadata && details.metadata.currency}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Order Id</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details.orderId}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Courses</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {details.products.map((item) => (
                            <Chip label={item.title} />
                          ))}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.leaddetails}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Created At</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {moment(details.createdAt).format('MMMM Do, YYYY')}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div className={classes.fontlead}>Updated At</div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className={classes.fontanswer}>
                          {moment(details.updatedAt).format('MMMM Do, YYYY')}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default View;
